import {Component} from '@angular/core';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {ApiService} from '../services/api.service';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';
import {
    faAngleLeft,
    faAngleRight,
    faCircleInfo,
    faFileExcel,
    faMagnifyingGlass,
    faPen,
    faPenToSquare,
    faSquarePlus,
    faTrash,
    faUpload,
    faWarning
} from '@fortawesome/free-solid-svg-icons';
import {getFileNameFromResponse} from '../../common/utils';
import saveAs from 'file-saver';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {GenericSearchComponent} from '../shared/search-suggestion/search-suggestion.component';
import {VehicleNumberCopyDirective} from '../shared/vehicle-number-copy/vehicle-number-copy.directive';
import {AlertTypeBadgeComponent} from '../shared/alert-type-badge/alert-type-badge.component';
import {
    MonitoringTypeMultiselectComponent
} from '../shared/monitoring-type-multiselect/monitoring-type-multiselect.component';
import {MonitoringTypeBadgeComponent} from '../shared/monitoring-type-badge/monitoring-type-badge.component';
import {MONITORING_TYPE_DISPLAY_ORDER} from '../shared/vehicle-monitoring/vehicle-monitoring.constants';
import {DEFAULT_TABLE_PAGE_SIZE_OPTIONS} from '../shared/constants/pagination.constants';

@Component({
    selector: 'app-alert',
    imports: [CommonModule, FormsModule, FontAwesomeModule, GenericSearchComponent, VehicleNumberCopyDirective, AlertTypeBadgeComponent, MonitoringTypeMultiselectComponent, MonitoringTypeBadgeComponent],
    templateUrl: './alert.component.html',
    styleUrl: './alert.component.css'
})
export class AlertComponent {
    readonly pageSizeOptions = DEFAULT_TABLE_PAGE_SIZE_OPTIONS;

  searchText: string = '';
  alertType: string = '';
    selectedMonitoringTypes: string[] = [];
  dateFilter: string = "today";
  recordsPerPage: number = 10;
  dateOptions = [
    { label: 'Today', value: 'today' },
    { label: 'Yesterday', value: 'yesterday' },
    { label: 'Last 7 days', value: 'last_7_days' },
    { label: 'Last one month', value: 'last_one_month' }
  ];
  alertTypeOptions = [
      {value: 'BLOCKLIST', label: 'Blacklist'},
      {value: 'HOTLIST', label: 'Hotlist'},
      {value: 'VEH_ALERT', label: 'Vehicle Monitoring'},
  ];
  currentPage: number = 1;
  alertData: any = [];
  nextPage: number | null = null;
  previousPage: number | null = null;
  limit: number = 10;
  showConfirmationDialog: boolean = false;
  pId: number = 0;
  totalRecords: number = 0
  todayDate: Date = new Date();


  constructor(public apiService: ApiService,
    library: FaIconLibrary,
    private router: Router,
    private toastr: ToastrService) {
    this.fetchData(this.currentPage, this.recordsPerPage);
    library.addIcons(faTrash,
      faFileExcel,
      faAngleRight,
      faAngleLeft,
      faUpload,
      faSquarePlus,
      faMagnifyingGlass,
      faPen,
      faPenToSquare,
      faWarning,
      faCircleInfo
    );
  }

  fetchData(page: number, pageSize: number) {
      this.apiService.alert(
          page,
          pageSize,
          this.searchText,
          this.alertType,
          this.dateFilter,
          this.showMonitoringTypeFilter ? this.selectedMonitoringTypes : [],
      ).subscribe(data => {
      this.alertData = data['results'];

      this.totalRecords = data['count'];
      this.nextPage = data['next']
      this.previousPage = data['previous']

    });
  }

  get totalPages(): number {
    let totalPage = Math.ceil(this.totalRecords / this.recordsPerPage);
    if (totalPage === 0) {
      totalPage = 1;
    }
    return totalPage;
  }

  next() {
    if (this.nextPage) {
      this.currentPage++;
      this.fetchData(this.currentPage, this.recordsPerPage);
    }
  }

  previous() {
    if (this.previousPage) {
      this.currentPage--;
      this.fetchData(this.currentPage, this.recordsPerPage);
    }
  }

  selectPageSize() {
    if (this.recordsPerPage) {
      this.currentPage = 1;
      this.fetchData(this.currentPage, this.recordsPerPage);
    }
  }
  openConfirmationDialog(index: number) {
    this.showConfirmationDialog = true;
    this.pId = index;
  }

  closeConfirmationDialog() {
    this.showConfirmationDialog = false;
  }

  confirmDelete() {
    this.apiService.deleteVehicle(this.pId).subscribe({
      next: (response: any) => {
        this.toastr.success('Vehicle deleted successfully.', 'Success');
        this.closeConfirmationDialog();
        // this.router.navigate(['/vehicle']);
        window.location.reload();
      },
      error: (err) => {
        if (err['error']['detail']) {
          this.toastr.error(err['error']['detail'], 'Error');

        } else if (err['status'] !== 403 && err.status !== 0) {
          this.toastr.error("Something went wrong!", 'Error');
        }
        this.closeConfirmationDialog();
      }
    })
  }

  vehicleSearch() {
    this.currentPage = 1;
    this.fetchData(this.currentPage, this.recordsPerPage);
  }

  applyFilters() {
      if (!this.showMonitoringTypeFilter) {
          this.selectedMonitoringTypes = [];
      }
      this.currentPage = 1;
      this.fetchData(this.currentPage, this.recordsPerPage);
  }

    get showMonitoringTypeFilter(): boolean {
        return this.alertType === 'VEH_ALERT';
    }

    get searchExtraBody(): Record<string, string> {
        const body: Record<string, string> = {};
        if (this.alertType) {
            body['alert_type'] = this.alertType;
        }
        if (this.dateFilter) {
            body['date_filter'] = this.dateFilter;
        }
        if (this.showMonitoringTypeFilter && this.selectedMonitoringTypes.length) {
            body['monitoring_types'] = this.selectedMonitoringTypes.join(',');
        }
        return body;
    }

    applyMonitoringTypeFilter(selectedValues: string[]) {
        this.selectedMonitoringTypes = selectedValues;
    this.currentPage = 1;
    this.fetchData(this.currentPage, this.recordsPerPage);
  }

    monitoringTypeCodes(record: { monitoring_types?: string[] }): string[] {
        const codes = record?.monitoring_types ?? [];
        return MONITORING_TYPE_DISPLAY_ORDER.filter(code => codes.includes(code));
    }

  exportToExcel() {
      this.apiService.exportAlerts(
          this.searchText,
          this.alertType,
          this.dateFilter,
          this.showMonitoringTypeFilter ? this.selectedMonitoringTypes : [],
      ).subscribe({
      next: (response: any) => {
        const fileName = getFileNameFromResponse(response);
          if (response.body) {
              saveAs(response.body, fileName);
          }
      },
      error: (err) => {
        this.toastr.error(`${err}`, 'Error')
      }
    })
  }

  onResults(event: { searchText: string, results: any[], totalRecords: number, nextPage: number | null, previousPage: number | null }) {
    this.currentPage = 1;
    this.recordsPerPage = 10;
    this.previousPage = event.previousPage;
    this.nextPage = event.nextPage;
    this.searchText = event.searchText;
    this.alertData = event.results;
    this.totalRecords = event.totalRecords;
  }

}
